<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش موجودی انبار</h5>
        <div style="flex: 1"></div>
      </div>
      <div class="row px-4 not-in-print">
        <div class="col-md-12">
          <div class="col-5">
            <b-form-group label="دسته بندی">
                <treeselect
                    :options="realOptions"
                    v-model="category_id"
                    :searchable="true"
                    :show-count="true"
                    noChildrenText="فرزندی وجود ندارد"
                    noOptionsText="موردی وجود ندارد"
                    noResultsText="موردی یافت نشد"
                    :default-expand-level="1"
                    label="title"
                >
                    <label
                    slot="option-label"
                    slot-scope="{
                        node,
                        shouldShowCount,
                        count,
                        labelClassName,
                        countClassName,
                    }"
                    :class="labelClassName"
                    >
                    {{ node.label }}
                    </label>
                </treeselect>
            </b-form-group>
        </div>
      </div>
        <ProductSearch
        class="col-md-12"
        ref="productSearch"
        :selectable="true"
        :disabled="disabled"
        @selectProduct="selectProduct"
        :show-label="false"
        @selectVariety="selectVariety"
        />
        <b-button
          class="col-md-2"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template v-slot:cell(purchase_price)="data">
            {{ data.item.purchase_price | price }}
          </template>
          <template v-slot:cell(sell_price)="data">
            {{ data.item.sell_price | price }}
          </template>
          <template v-slot:cell(product_title)="data">
            <a target="_blank" :href="'/admin/products/edit/' + data.item.id">{{
              data.item.product_title
            }}</a>
          </template>
          <template v-slot:cell(quantity)="data">
            {{ data.item.quantity | price }}
          </template>
          <template #bottom-row="data">
            <b-td colspan="2">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
              {{ totals.quantity | price }}
            </b-td>
            <b-td>
              {{ totals.purchase_price | price }} تومان</b-td
            >
            <b-td>
              {{ totals.sale_price | price }} تومان</b-td
            >
          </template>
        </b-table>

        <div v-if="reports && !reports.length" class="alert alert-primary">اطلاعاتی موجود نیست</div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "storeBalanceReport",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    Treeselect,
    ProductSearch,
    BButton,
    BTd,
  },
  configProvider,
  data() {
    return {
      disabled: true,
      fields: [
        {
          key: "id",
          label: "شناسه محصول",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "quantity",
          label: "موجودی ",
        },
        {
          key: "purchase_price",
          label: "قیمت خرید(تومان) ",
        },
        {
          key: "sell_price",
          label: "قیمت فروش(تومان) ",
        },
      ],
      page: 1,
      reports: null,
      sortBy: null,
      Product_id: "",
      Variety_id: "",
      sortDesc: null,
      categories: [],
      category_id: null,
      totals: "",
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  created() {
    this.loadCategoriesData();
  },
  computed: {
      realOptions() {
        console.log(this.categories);
        let temp = this.$root.addLabel(this.categories);
        console.log(temp);
        temp.unshift({
            label: "ندارد",
            children: [],
            id: 0,
        });

        return temp;
      },
  },
  methods: {
    resetFilter() {
      this.Product_id = "";
      this.category_id = "";
      this.Variety_id = "";
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    async loadCategoriesData() {
        try {
        const response = await this.$axios.get("admin/categories",{params: {all: 1},});
        this.categories = response.data.data.categories;
        } catch (e) {
            this.$root.notify(e);
        } finally {
            this.disabled = false;
        }
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    async loadData() {
      this.disabledRest = false;
      try {
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/reports/store-balance-new",
          {
            params: {
              category_id: this.category_id ? this.category_id : '',
              product_id: this.Product_id.id ? this.Product_id.id : '',
              variety_id: this.Variety_id.id ? this.Variety_id.id : '',
            },
          }
        );
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-varieties-modal");
      this.showVarietiesProductId = productId;
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
